module.exports = __webpack_public_path__ + "static/media/S (180).c936b5be.jpg";